module.exports = __webpack_public_path__ + "bRIe_XFrtjaX0I2nF/white-logo.svg";